  import { Fragment, useContext, useRef, useState } from "react";
  import { Dialog, Transition } from "@headlessui/react";
  import { PlusIcon } from "@heroicons/react/outline";
  import AuthContext from "../../AuthContext";
  import {toast} from 'react-toastify' 
  import Course from '../Dropdowns/CourseName'
  import BatchPhase from '../Dropdowns/BatchPhase'
  import Scheme from '../Dropdowns/Scheme'
  import Centre from '../Dropdowns/Centre'
  import Trainer from '../Dropdowns/Trainer'
  import axiosInstance from '../../axios'

  export default function AddProduct({
    addProductModalSetting,
    handlePageUpdate,
  }) {
    const authContext = useContext(AuthContext);
    const imp=true
    const [update,setUpdate]=useState(false)
    const[course,setCourse]=useState('')
    const[centre,setCentre]=useState(authContext.centre?authContext.centre:'')
    const[scheme,setScheme]=useState('')
    const[bphase,setBphase]=useState('Created')
    const[status,setStatus]=useState('upcoming')
    const[trainer,setTrainer]=useState('')
    const [batch, setBatch] = useState({
      batch_name:'',
      batch_type:'',
      tbn_no:'',
      start_date:'',
      end_date:'',
      status:'',
      capacity:'',
      trainer_id:'',
      to_enrolled_no:'',
      assesment_date:'',
      assesment_id:'',
      assest_by:'',
      training_type:'',
      rpl_type:'',
      to_time:0,
      daily_training_duration:'',
      ojt_start_date:'',
      ojt_end_date:'',
  });
    const [open, setOpen] = useState(true);
    const cancelButtonRef = useRef(null);
    const handleInputChange = (e) => {
      const { name, value } = e.target;

    const imp=true
      setBatch(prevState => ({
        ...prevState,
        [name]: value
      }));
    if(name==='assesment_date'&& value< batch.end_date){
      toast.error('Assessment cannot be done before Batch is Completed');
      return;
    }
      // Check if start date is greater than end date
  
      if (name === 'end_date' && value < batch.start_date) {
        // Display error message or prevent form submission
        toast.warning('End date cannot be before than Start date');
      }
      // Check if any field is empty
  
    };
    const resetForm=()=>{
      setBatch({
        batch_name:'',
        batch_type:'',
        tbn_no:'',
        start_date:'',
        end_date:'',
        status:'',
        capacity:'',
        trainer_id:'',
        to_enrolled_no:'',
        assesment_date:'',
        assesment_id:'',
        assest_by:'',
        training_type:'',
        rpl_type:'',
        to_time:'',
        daily_training_duration:'',
        ojt_start_date:'',
        ojt_end_date:'',
      })
      setTrainer('')
      setCentre('')
      setCourse('')
      setScheme('')
      setStatus('')
      setBphase('Created')
    }
    const addbatch= () => {

  const requiredFields={
    "Batch Name":batch.batch_name,
    "Batch Type":batch.batch_type,
    "Batch Id/TBN No.":batch.tbn_no,
    "Start Date":batch.start_date,
    "End Date":batch.end_date,
    "Status":status,
    "Capacity":batch.capacity,
    "Trainer":trainer,
    "Total Enrolled":batch.to_enrolled_no,
    "Assessment Date":batch.assesment_date,
    "Assessment ID":batch.assesment_id,
    "Assessed By":batch.assest_by,
    "Daily Training Duration":batch.daily_training_duration,
    "OJT Start Date":batch.ojt_start_date,
    "OJT End Date":batch.ojt_end_date,
    "Scheme Name":scheme,
    "Batch Phase":bphase
  }
      const missingFields = Object.keys(requiredFields).filter(key => {
        const field = requiredFields[key];
        return !field || (Array.isArray(field) && field.length === 0);
      });
      
      if (missingFields.length > 0) {
        console.error('The following fields are missing:', missingFields);
        toast.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
        return;
      }

      
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      axiosInstance.post(`/batch/insert`,{
        batch_name:batch.batch_name,
        batch_type:batch.batch_type,
        start_date:formatDate(batch.start_date),
        end_date:formatDate(batch.end_date),
        status:status,
        capacity:batch.capacity,
        to_enrolled_no:batch.to_enrolled_no,
        assesment_date:batch.assesment_date,
        assesment_id:batch.assesment_id,
        assest_by:batch.assest_by,
        training_type:batch.training_type,  
        rpl_type:batch.rpl_type,
        to_time:batch.to_time||0,
        daily_training_duration:batch.daily_training_duration,
        ojt_start_date:formatDate(batch.ojt_start_date),
        ojt_end_date:formatDate(batch.ojt_end_date),
        course_id:course,
        trainer_id:trainer,
        centre_id:centre,
        scheme_id:scheme,
        batch_phase:bphase,
        tbn_no:batch.tbn_no
      })
      .then((res)=> {
        toast.success("New Batch Added")
        handlePageUpdate()
        resetForm()
      })
      .catch((err)=> {
        console.log(err) 
        toast.error('Something went wrong')});
    
  
    }
    return (
      // Modal
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                        <PlusIcon
                          className="h-6 w-6 text-blue-400"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                        <Dialog.Title
                          as="h3"
                          className="text-lg font-semibold leading-6 text-gray-900 "
                        >
                          Add Batch
                        </Dialog.Title>
                        <form action="#" aria-autocomplete="true">
                          <div className="grid gap-4 mb-4 sm:grid-cols-4">
                          {(authContext.userType==='Superadmin'||authContext.userType==='Manager') &&(
    <Centre value={centre} handleInputChange={(e)=>{setCentre(e.target.value);setUpdate(!update)}} imp={imp}/>
  )}
                            <div>
                              <BatchPhase value={bphase} handleChange={e=>setBphase(e.target.value)} imp={imp}/>
                            </div>
                          <div>
                                <label htmlFor="batch_name"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  Batch Name </label>
                              <input
                              type="text"
                              id="batch_name"
                              name="batch_name"
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"    
                          value={batch.batch_name}
                              onChange={handleInputChange}
                              />

                              </div>
                              
                              <div>
                                <label htmlFor="tbn_no"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  TBN/Batch ID </label>
                              <input
                              type="text"
                              id="tbn_no"
                              name="tbn_no"
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
    focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
    dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
    value={batch.tbn_no}
                              onChange={handleInputChange}
                              />

                              </div>
                              <div>
                            <Scheme value={scheme} handleInputChange={e=>{setScheme(e.target.value);setUpdate(!update)}} centre={centre} imp={imp}/>
                              </div>
                              <div>
                              <label htmlFor="status"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  Status </label>
                                  <select
                  id="status"
                  value={status}
                  onChange={e=>setStatus(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                  >
                  <option value='' disabled>------Select-----</option>
                  <option value="upcoming">Upcoming</option>
                  <option value="running">Running</option>
                  <option value="completed">Completed</option>

                


              </select>
              </div>
                              <div>
                                <label htmlFor="batch_type"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  Batch Type</label>
                              <input
                              type="text"
                              id="batch_type"
                              name="batch_type"
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
  value={batch.batch_type}
                              onChange={handleInputChange}
                              />

                              </div>
  <div>
    <Course value={course} handleInputChange={(e)=>{setCourse(e.target.value) ;setUpdate(!update)}} imp={imp} centre={centre}/>
  </div>

  <div>

                              <label
                                  htmlFor="start_date"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >
                                  Start Date 
                                </label>
                                <input
                                type="date"
                                id="start_date"
                                name="start_date"
                                value={batch.start_date}
                                onChange={handleInputChange}
      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                />
                              </div>
                              <div>
                              <label
                                  htmlFor="end_date"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >
                                  End Date 
                                </label>
                                <input
                                type="date"
                                id="end_date"
                                name="end_date"
                                value={batch.end_date}
                                onChange={handleInputChange}
      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                />
                            
                              </div>
                              <div>
                                <label htmlFor="capacity"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  TC Capacity </label>
                              <input
                              type="number"
                              id="capacity"
                              name="capacity"
                                value={batch.capacity}
                                onChange={handleInputChange}
      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                />

                              </div>
                            
                              <div>
                                <label htmlFor="assesment_id"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  Assessment Batch No.</label>
                                <input
                                type="number"
                                id='assesment_id'
                                name='assesment_id'
                                value={batch.assesment_id}
                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                  onChange={handleInputChange}
                                  
                                />

                              </div>
                          
                              <div>
                                <label htmlFor="assest_by"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  Assessed By </label>
                              <input
                              type="text"
                              id="assest_by"
                              name="assest_by"
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
    focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
    dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
    value={batch.assest_by}
                              onChange={handleInputChange}
                              />

                              </div>
                            
                            
                              <div>
                                <label htmlFor="training_type"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Training Type</label>
                              <input
                              type="text"
                              id="training_type"
                              name="training_type"
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
    focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700
    dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 
    dark:focus:border-blue-500"                            
    value={batch.training_type}
                              onChange={handleInputChange}
                              />

                              </div>
                              <div>
                              <Trainer value={trainer} handleInputChange={e=>{setTrainer(e.target.value);setUpdate(!update)}} course={course} imp={imp} />

                              </div>
                              <div>
                                <label htmlFor="assesment_date"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  Assessment Date </label>
                              <input
                              type="date"
                              id="assesment_date"
                              name="assesment_date"
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
    focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
    dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                           
      value={batch.assesment_date}
                              onChange={handleInputChange}
                              />

                              </div>
                              <div>
                                <label htmlFor="to_enrolled_no"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Batch Size </label>
                              <input
                              type="number"
                              id="to_enrolled_no"
                              size={1}
                              name="to_enrolled_no"
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg
                                focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5
                                dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white 
                                dark:focus:ring-blue-500 dark:focus:border-blue-500"                           
                              value={batch.to_enrolled_no}
                              onChange={handleInputChange}
                              />
                              </div>
                              <div>
                                <label htmlFor="ojt_start_date"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  On Job Training Start Date </label>
                              <input
                              type="date"
                              id="ojt_start_date"
                              name="ojt_start_date"
                              value={batch.ojt_start_date}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   

                              onChange={handleInputChange}
                              />

                              </div>
                              <div>
                                <label htmlFor="ojt_end_date"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  On Job Training End Date </label>
                              <input
                              type="date"
                              id="ojt_end_date"
                              value={batch.ojt_end_date}
                              name="ojt_end_date"
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                         
                              onChange={handleInputChange}
                              />

                              </div>
                              <div>
                              <label htmlFor="daily_training_duration"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                  Daily Training Duration </label>
                              <input
                              type="text"
                              id="daily_training_duration"
                              value={batch.daily_training_duration}
                              name="daily_training_duration"
  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                         
                              onChange={handleInputChange}
                              />
                              </div>

                            </div>
                            
                                  <div className="flex items-center space-x-4">
                                  
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            <button
                              type="button"
                              className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                              onClick={addbatch}
                            >
                              Add Batch
                            </button>
                            <button
                              type="button"
                              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                              onClick={() => addProductModalSetting()}
                              ref={cancelButtonRef}
                            >
                              Cancel
                            </button>
                          </div>
                        </Dialog.Panel>
                      </Transition.Child>
                    </div>
                  </div>
                </Dialog>
              </Transition.Root>
            );
          }
